import { Box, Button } from '@mui/material'
import { sendGet, sendPost } from '../../hooks/use-fetch'
import { useEffect, useState } from 'react'
import { CheckList } from '../../Components/CheckList'
import { DatePickerWithLabel } from '../../Components/DatePicker'
import { SelectWithLabel, type SelectOption } from '../../Components/SelectWithLabel'
import { useAccountId } from '../../ContextProviders/CurrentAccount'
import { toast } from 'react-toastify'
import { AccountType, type ActiveAccount } from '../../core/types'

export function ChildEnrollmentDetailOptions (): JSX.Element {
  const [dobStartDate, setDOBStartDate] = useState<Date | null>(null)
  const [dobEndDate, setDOBEndDate] = useState<Date | null>(null)
  const [enrollStartDate, setEnrollStartDate] = useState<Date | null>(null)
  const [enrollEndDate, setEnrollEndDate] = useState<Date | null>(null)
  const [programs, setPrograms] = useState<Array<SelectOption<number>>>([])
  const [selectedPrograms, setSelectedPrograms] = useState<Array<SelectOption<number>>>([])
  const [serviceProviders, setServiceProviders] = useState<Array<SelectOption<number>>>([])
  const [selectedServiceProviders, setSelectedServiceProviders] = useState<Array<SelectOption<number>>>([])
  const [districts, setDistricts] = useState<Array<SelectOption<number>>>([])
  const [districtID, setSelectedDistrictID] = useState<number | undefined>(undefined)
  const account: ActiveAccount | undefined = useAccountId()

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response } = await sendGet('/Reporting/ISDPrograms', {})
      setPrograms(response)
      const { response: r2 } = await sendGet('/Reporting/ISDServiceProviders', {})
      setServiceProviders(r2)
      const { response: r3 } = await sendGet('/Reporting/ResidentDistricts', {})
      setDistricts(r3)
    }

    void fetchData()
  }, [])

  const openReport = async (): Promise<void> => {
    if (dobStartDate === null && dobEndDate === null && enrollStartDate === null && enrollEndDate === null) {
      toast.error('Please enter a DOB date range or an Enrollment date range .')
    } else if ((dobStartDate === null) !== (dobEndDate === null)) { // doing an XOR here
      toast.error('Please enter both values for the DOB date range.')
    } else if ((enrollStartDate === null) !== (enrollEndDate === null)) {
      toast.error('Please enter both values for the Enrollment date range.')
    } else {
      const isdServiceProviderIDs: number[] = selectedServiceProviders.map(s => s.id)
      const ISDProgramIDs = selectedPrograms.map(s => s.id)
      const { response, success } = await sendPost('/Reporting/ChildEnrollmentDetailReportURL', { dobStartDate, dobEndDate, enrollStartDate, enrollEndDate, isdServiceProviderIDs, ISDProgramIDs, districtID })
      if (success) {
        window.open(response, '_blank')?.focus()
      }
    }
  }

  return <>
    <Box className='mt-10'>
      <DatePickerWithLabel
        label='DOB Start Date'
        name='dobStartDate'
        onChange={setDOBStartDate}
        value={dobStartDate}
      />
      <DatePickerWithLabel
        label='DOB End Date'
        name='dobEndDate'
        onChange={setDOBEndDate}
        value={dobEndDate}
      />
      <DatePickerWithLabel
        label='Enrollment Date, Begin Range'
        name='enrollStartDate'
        onChange={setEnrollStartDate}
        value={enrollStartDate}
      />
      <DatePickerWithLabel
        label='Enrollment Date, End Range'
        name='enrollEndDate'
        onChange={setEnrollEndDate}
        value={enrollEndDate}
      />
      <SelectWithLabel
        includeNoneOption={true}
        noneOptionText='(any)'
        name="districtID"
        label="Resident District"
        value={districtID}
        width="100%"
        options={districts}
        onChange={(e) => { setSelectedDistrictID(Number(e.target.value)) }}
      />

      <CheckList label='Programs' items={programs} selectedItems={selectedPrograms} setSelectedItems={setSelectedPrograms} allOption={true} />

      {account !== undefined && account.type !== AccountType.SERVICE_PROVIDER &&
        <CheckList label='Service Providers' items={serviceProviders} selectedItems={selectedServiceProviders} setSelectedItems={setSelectedServiceProviders} allOption={true} />
      }
    </Box>

    <Box className='mt-10'>
      <Button color='secondary' variant='contained' onClick={openReport}>Preview</Button>
    </Box>
  </>
}
